import React, { useContext, useEffect, useState } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import { FullGridContext } from "../..";
import { getData } from "~/functions/gridFunctions";
import PageContainer from "~/components/PageContainer";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";
import ModalFilters from "./ModalFilters";
import GenerateModal from "./GenerateModal";
import api from "~/services/api";

export default function Timesheets() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "created_at", asc: false };
  const defaultGridHeader = [
    {
      title: "Staff",
      name: "staff_name",
      type: "text",
      filter: false,
    },
    {
      title: "Period From",
      name: "period_from",
      type: "text",
      filter: false,
    },
    {
      title: "Period To",
      name: "period_to",
      type: "text",
      filter: false,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
    {
      title: "Created At",
      name: "created_at",
      type: "text",
      filter: false,
    },
    {
      title: "Approved At",
      name: "approved_at",
      type: "text",
      filter: false,
    },
  ];

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children
    .find((el) => el.alias === "hr")
    ?.children?.find((el) => el.alias === "hr-timesheet");

  const { pathname } = useLocation();

  const [filtersModalOpened, setFiltersModalOpened] = useState(false);
  const [applyingFilters, setApplyingFilters] = useState(false);
  const [generateModalOpened, setGenerateModalOpened] = useState(false);
  const [activeFiltersData, setActiveFiltersData] = useState({});

  const handleApplyFilters = async (filters) => {
    setApplyingFilters(true);
    console.log("Filters applied:", filters);
    setActiveFiltersData(filters);
    setPage(1);
    setApplyingFilters(false);
  };

  const handleSelectStaff = (staff) => {
    console.log("Staff selected:", staff);
  };

  const handleTimesheetsGenerated = () => {
    // Reload the datatable after timesheets are generated
    loader();
  };

  async function loader() {
    setLoadingData(true);

    try {

      const currentOrderBy = orderBy || defaultOrderBy;


      let queryParams = new URLSearchParams({
        limit: limit,
        page: page,
        orderBy: currentOrderBy.column,
        orderASC: currentOrderBy.asc ? "ASC" : "DESC",
        search: search?.value || "",
        type: activeFiltersData.type || "null",
      });


      if (activeFiltersData.status) {
        queryParams.append("status", activeFiltersData.status);
      }
      if (activeFiltersData.department) {
        queryParams.append("department", activeFiltersData.department);
      }
      if (activeFiltersData.periodFrom) {
        queryParams.append("from", activeFiltersData.periodFrom);
      }
      if (activeFiltersData.periodTo) {
        queryParams.append("to", activeFiltersData.periodTo);
      }

      console.log("Loading with query:", queryParams.toString());

      const response = await api.get(`/timesheet-periods?${queryParams.toString()}`);

      console.log("Response data:", response.data);

      const data = response.data.rows || [];
      const totalRows = response.data.totalRows || 0;

      console.log("Data rows:", data);
      console.log("Total rows:", totalRows);

      let pagesCount = Math.ceil(totalRows / limit);
      if (totalRows === 0) {
        setPages(1);
      } else {
        setPages(pagesCount);
      }

      setGridDetails({
        totalRows: totalRows,
        pages: pagesCount || 1,
      });

      const gridDataValues = data.map(
        (
          { id, staff_name, period_from, period_to, status, created_at, approved_at, canceled_at },
          index
        ) => {
          const ret = {
            show: true,
            id,
            fields: [
              staff_name,
              period_from ? format(new Date(`${period_from}T00:00:00`), "yyyy-MM-dd") : "-",
              period_to ? format(new Date(`${period_to}T00:00:00`), "yyyy-MM-dd") : "-",
              status,
              created_at ? format(new Date(created_at), "yyyy-MM-dd @ HH:mm") : "-",
              approved_at ? format(new Date(approved_at), "yyyy-MM-dd @ HH:mm") : "-",
            ],
            selectable: true,
            canceled: canceled_at,
            page: Math.ceil((index + 1) / limit),
          };
          return ret;
        }
      );

      console.log("Grid data values:", gridDataValues);
      setGridData(gridDataValues);
    } catch (err) {
      console.error("Error loading timesheets:", err);
      setGridData([]);
    }

    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page, activeFiltersData]);

  useEffect(() => {
    return () => {
      setOpened(null);
    };
  }, []);

  return (
    <>
      <ModalFilters
        opened={filtersModalOpened}
        onClose={() => setFiltersModalOpened(false)}
        applying={applyingFilters}
        onApplyFilters={handleApplyFilters}
      />
      <GenerateModal
        opened={generateModalOpened}
        onClose={() => setGenerateModalOpened(false)}
        onSelectStaff={handleSelectStaff}
        onTimesheetsGenerated={handleTimesheetsGenerated}
      />
      <PageContainer
        FullGridContext={FullGridContext}
        PagePreview={PagePreview}
        pageAccess={pageAccess}
        defaultGridHeader={defaultGridHeader}
        filtersModal={{
          onOpen: () => setFiltersModalOpened(true),
        }}
        generateModal={{
          onOpen: () => setGenerateModalOpened(true),
        }}
      />
    </>
  );
}
